import { useState } from "react";

import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";


export const ActionConfirmDialog = ({
  triggerLabel,
  title,
  message,
  noteLabel = "Internal note",
  notePlaceholder = "Add an internal note for audit history (strongly encouraged)",
  onConfirm,
  testIdPrefix,
  triggerTestId,
  triggerVariant = "default",
  triggerClassName = "",
  triggerDisabled = false,
}) => {
  const [open, setOpen] = useState(false);
  const [note, setNote] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const closeDialog = () => {
    setOpen(false);
    setNote("");
    setError("");
    setLoading(false);
  };

  const handleConfirm = async () => {
    setLoading(true);
    setError("");
    try {
      await onConfirm(note.trim());
      closeDialog();
    } catch (messageText) {
      setLoading(false);
      setError(messageText || "We could not complete this action.");
    }
  };

  return (
    <Dialog open={open} onOpenChange={(nextOpen) => { setOpen(nextOpen); if (!nextOpen) closeDialog(); }}>
      <DialogTrigger asChild>
        <Button variant={triggerVariant} className={triggerClassName} data-testid={triggerTestId || `${testIdPrefix}-trigger-button`} disabled={triggerDisabled}>{triggerLabel}</Button>
      </DialogTrigger>
      <DialogContent className="border-stone-200 bg-white" data-testid={`${testIdPrefix}-dialog`}>
        <DialogHeader>
          <DialogTitle data-testid={`${testIdPrefix}-title`}>{title}</DialogTitle>
          <DialogDescription data-testid={`${testIdPrefix}-description`}>{message}</DialogDescription>
        </DialogHeader>
        <div className="space-y-3" data-testid={`${testIdPrefix}-note-section`}>
          <label className="text-sm font-medium text-slate-800" htmlFor={`${testIdPrefix}-note-input`}>{noteLabel}</label>
          <Textarea id={`${testIdPrefix}-note-input`} value={note} onChange={(event) => setNote(event.target.value)} placeholder={notePlaceholder} data-testid={`${testIdPrefix}-note-input`} />
          <p className="text-xs text-slate-500" data-testid={`${testIdPrefix}-note-help-text`}>This note is internal only and will be stored in audit history for accountability.</p>
        </div>
        {error && <p className="text-sm text-rose-700" data-testid={`${testIdPrefix}-error-text`}>{error}</p>}
        <DialogFooter>
          <Button variant="outline" className="rounded-full" onClick={closeDialog} data-testid={`${testIdPrefix}-cancel-button`}>Cancel</Button>
          <Button className="rounded-full" onClick={handleConfirm} disabled={loading} data-testid={`${testIdPrefix}-confirm-button`}>{loading ? "Processing..." : "Confirm action"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
